import React, { useState } from 'react';
import './RegistrationModal.css';

export const RegistrationModal = ({ isOpen, onClose, message, isSuccess, isGerman }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal-container">
        <div className={`modal-content ${isSuccess ? 'success' : 'error'}`}>
          <div className="modal-icon">
            {isSuccess ? '✓' : '✗'}
          </div>
          <h2>{isSuccess 
            ? (isGerman ? 'Registrierung erfolgreich!' : 'Registration Successful!') 
            : (isGerman ? 'Registrierung fehlgeschlagen' : 'Registration Failed')
          }</h2>
          <p className="modal-message">{message}</p>
          
          {isSuccess && (
            <p className="modal-hint">
              {isGerman
                ? '📧 Eine E-Mail mit Ihrem Passwort wurde gesendet. Bitte prüfen Sie Ihren Posteingang.'
                : '📧 An email with your password has been sent. Please check your inbox.'
              }
            </p>
          )}
          
          <button onClick={onClose} className="modal-button" data-testid="modal-ok-button">
            OK
          </button>
        </div>
      </div>
    </>
  );
};
